var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    clipPath: "url(#clip0_58_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.6667 11C37.1529 11 37.6192 11.1932 37.963 11.537C38.3068 11.8808 38.5 12.3471 38.5 12.8333V31.1667C38.5 31.6529 38.3068 32.1192 37.963 32.463C37.6192 32.8068 37.1529 33 36.6667 33H16.5L7.33333 23.8333C6.88237 23.3291 6.63306 22.6764 6.63306 22C6.63306 21.3236 6.88237 20.6709 7.33333 20.1667L16.5 11H36.6667Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 18.3334L29.3333 25.6667M29.3333 18.3334L22 25.6667",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_58_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDelete);
export default __webpack_public_path__ + "static/media/arrowDelete.2cbdf843ed2bfb9d512182842dd4ce5e.svg";
export { ForwardRef as ReactComponent };